package diana.soleil.design.iraniancanadienbazzar.core.common

// navigator.language is e.g. "en-US"/"fr-CA"; take the region subtag (dependency-free JS interop).
actual fun deviceRegionCode(): String? =
    (js("navigator.language") as? String)?.substringAfter('-', "")?.ifBlank { null }?.uppercase()
